import React from 'react'
import { useHistory } from 'react-router'

// graphql
import { useQuery } from '@apollo/client'
import { GET_JOB_BY_ID_WITH_NAME } from '../../../../../graphql/job/job.queries'

// components
import ActionButton from '../../../../../components/buttons/ActionButton/ActionButton.component'

// mui
import { Grid, Container, Typography } from '@mui/material'

export default function JobName({ jobId }) {
    const history = useHistory()
    let job = {}

    const { data } = useQuery(GET_JOB_BY_ID_WITH_NAME, {
        variables: { id: jobId }
    })

    if(data && data.jobLite) {
        job = {...data.jobLite}
    }

    return (<Container disableGutters>
        <Grid container spacing={2} justifyContent='space-between' alignItems={'center'}>
            <Grid item><Typography variant="h2">{job.name}</Typography></Grid>
            <Grid item><ActionButton label="New Request" onClick={() => history.push(`/requests/new/${jobId}`)} /></Grid>
        </Grid>
    </Container>)
}